import React, {Component} from  "react";
import {Row, Col, Divider, Icon} from 'antd';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import Expandable from '../utils/expandable'
import { getAllApps } from './app_maker'
import { getAllAppIcons } from './app_icon_maker'

import AppIcon from '../utils/app_icon'
import { globalUrlPrefix } from '../../utils/const'
import logo_square from "../../asset/img/logo_square.png"
import "../../asset/style/neoviewer/appboard.css"

const dashboardKey = {
    id: "dashboard", 
    title: "Dashboard", 
    showTitle: true
}

class AppBoard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showBoard: false,
            showTrigger: true
        }
    }

    setShowBoard = (value) => {
        this.setState({
            showBoard: value
        })
    }

    setShowTrigger = (value) => {
        this.setState({
            showTrigger: value
        })
    }

    render(){

        if (!this.props.urlState.apps_initialised) return null;

        let apps = getAllApps(this.props.slideState, this.props.urlState);
        let appIcons = getAllAppIcons(this.props.urlState);

        let appBoardSize = Math.ceil(Math.sqrt(appIcons.length));

        let colSpan = 24 / appBoardSize;

        let appIconsRow = [];
        let appIconsCol = [];
        let counter = 0;

        for (var i in appIcons) {
            counter ++;
            appIconsCol.push(
                <Col key={i} span={colSpan}>{appIcons[i]}</Col>
            )
            if (counter >= appBoardSize) {
                appIconsRow.push(
                    <Row key={i}>{appIconsCol}</Row>
                )
                appIconsCol = [];
                counter = 0;
            }
        }

        if (appIconsCol.length > 0) {
            appIconsRow.push(
                <Row key={appIcons.length + 1}>{appIconsCol}</Row>
            )
        }

        let appBoardDiv = <Row className="appboard-icons-grid">
                            <Col span={2}>
                                <NavLink to={'/' + globalUrlPrefix + '/dashboard/'} className="dashboard-icon">
                                    <AppIcon key={dashboardKey.id}
                                        appKey={dashboardKey} 
                                        openable={false}
                                        content={
                                            <Icon type="layout" />
                                        } />
                                </NavLink>
                            </Col>
                            <Divider width={80}/>
                            <Col>
                                {appIconsRow}
                            </Col>
                        </Row>

        let closedContent = <div>
                                <img className="appboard-trigger" src={logo_square} />
                            </div>

        return (
            <Row className="appboard" id="appboard">
                <Expandable 
                    className="appboard-parent"
                    closedContent={closedContent}
                    expandedContent={<div>{appBoardDiv}</div>}
                    closedClassName="appboard-closed"
                    expandedClassName="appboard-expanded" 
                    />
                    {apps}
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        urlState: state.viewerUrlReducer
    }
}

export default connect(mapStateToProps)(AppBoard);